var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5403 40H2.41275C1.08574 40 0 38.8 0 37.3333V2.66667C0 1.2 1.08574 0 2.41275 0H26.5403C27.8673 0 28.953 1.2 28.953 2.66667V37.3333C28.953 38.8 27.8673 40 26.5403 40Z",
    fill: "url(#paint0_linear_26_108)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 4H10.8574V5.33333H2.41275V4Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 8H25.3339V9.33333H2.41275V8Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 12H25.3339V13.3333H2.41275V12Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 16H25.3339V17.3333H2.41275V16Z",
    fill: "#BDBDBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 20H25.3339V21.3333H2.41275V20Z",
    fill: "#BDBDBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 24H19.302V25.3333H2.41275V24Z",
    fill: "#BDBDBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 28H16.8893V29.3333H2.41275V28Z",
    fill: "#BDBDBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41275 32H8.44463V33.3333H2.41275V32Z",
    fill: "#BDBDBD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.5403 1C27.3727 1 28.0482 1.74667 28.0482 2.66667V37.3333C28.0482 38.2533 27.3727 39 26.5403 39H2.41275C1.58035 39 0.904781 38.2533 0.904781 37.3333V2.66667C0.904781 1.74667 1.58035 1 2.41275 1H26.5403ZM26.5403 0H2.41275C1.08574 0 0 1.2 0 2.66667V37.3333C0 38.8 1.08574 40 2.41275 40H26.5403C27.8673 40 28.953 38.8 28.953 37.3333V2.66667C28.953 1.2 27.8673 0 26.5403 0Z",
    fill: "#424242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69625 32.0499L11.0625 28.0199L12.0034 25.2466C12.2146 24.5299 12.5765 23.8799 13.059 23.3466L15.2305 20.9466L20.8612 27.1699L18.6898 29.5699C18.2072 30.1033 17.6191 30.5033 16.9707 30.7366L14.4614 31.7766L10.8152 33.2866C10.1245 33.5333 9.47005 32.8099 9.69625 32.0499Z",
    fill: "url(#paint1_linear_26_108)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.2275 22.3599L19.5765 27.1666L18.0444 28.8599C17.6644 29.2799 17.1939 29.5999 16.6842 29.7833L16.648 29.7966L14.1387 30.8366L10.5709 32.3133L11.9069 28.3699L12.8479 25.5966L12.86 25.5566C13.0259 24.9933 13.3154 24.4733 13.6954 24.0533L15.2275 22.3599ZM15.2275 20.9466L13.056 23.3466C12.5735 23.8799 12.2115 24.5299 12.0004 25.2466L11.0595 28.0199L9.69324 32.0499C9.50022 32.7066 9.95864 33.3333 10.5287 33.3333C10.6191 33.3333 10.7126 33.3166 10.8091 33.2833L14.4554 31.7733L16.9647 30.7333C17.6131 30.4999 18.2012 30.0999 18.6838 29.5666L20.8552 27.1666L15.2275 20.9466Z",
    fill: "#424242"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69625 32.05L11.0625 28.02C11.7742 28.41 12.4468 28.9334 13.0379 29.59C13.6321 30.2467 14.1025 30.9867 14.4584 31.7734L10.8122 33.2834C10.1245 33.5334 9.47006 32.81 9.69625 32.05Z",
    fill: "url(#paint2_linear_26_108)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.5299 29.4867C11.8406 29.7267 12.1301 29.9967 12.3985 30.2934C12.6669 30.59 12.9112 30.91 13.1284 31.2534L10.5709 32.3134L11.5299 29.4867ZM11.0625 28.02L9.69623 32.05C9.50321 32.7067 9.96163 33.3334 10.5316 33.3334C10.6221 33.3334 10.7156 33.3167 10.8121 33.2834L14.4584 31.7734C14.1055 30.9867 13.632 30.2434 13.0379 29.59C12.4468 28.9334 11.7742 28.41 11.0625 28.02Z",
    fill: "#424242"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6626 9.4133L31.2934 15.6366L33.1693 13.56L27.5416 7.33997L25.6626 9.4133Z",
    fill: "url(#paint3_linear_26_108)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9178 14.9464L26.2878 8.72393L26.9126 8.03333L32.5426 14.2558L31.9178 14.9464Z",
    fill: "#9E9E9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5415 7.34002L33.1723 13.5634L35.6755 10.7967C36.3662 10.0334 36.3662 8.79335 35.6755 8.03002L32.548 4.57335C31.8573 3.81002 30.7354 3.81002 30.0448 4.57335L27.5415 7.34002Z",
    fill: "url(#paint4_linear_26_108)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6256 13.79L27.3304 11.2533L15.7492 24.0533L15.7281 24.5533C15.6859 25.63 16.6178 26.66 17.589 26.61L18.0414 26.5866L29.6256 13.79Z",
    fill: "url(#paint5_linear_26_108)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2934 15.6367L19.1964 29.0067C18.5179 28.6933 17.9931 27.9067 18.0232 27.0933L18.0444 26.5933L29.6256 13.7933L31.2934 15.6367Z",
    fill: "url(#paint6_linear_26_108)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 11.2567L15.7522 24.0567L15.2998 24.08C14.564 24.1167 13.8522 23.5333 13.5687 22.7833L25.6656 9.41333L27.3334 11.2567Z",
    fill: "url(#paint7_linear_26_108)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.2934 5C31.5256 5 31.7428 5.1 31.9056 5.28L35.0332 8.73667C35.196 8.91667 35.2865 9.15667 35.2865 9.41333C35.2865 9.67 35.196 9.91 35.0332 10.09L19.106 27.6933C18.9914 27.52 18.922 27.32 18.928 27.1367L18.9492 26.6367L18.9914 25.5467L18.0052 25.5933L17.5528 25.6167H17.5286C17.3205 25.6167 17.0853 25.49 16.9043 25.28C16.7264 25.0767 16.6269 24.82 16.6359 24.6L16.657 24.1L16.6993 23.01L15.7131 23.0567L15.2607 23.08H15.2365C15.0767 23.08 14.9048 23.0067 14.757 22.8833L30.6842 5.28C30.847 5.1 31.0642 5 31.2934 5ZM31.2934 4C30.841 4 30.3886 4.19 30.0418 4.57333L13.5657 22.7833C13.8432 23.5133 14.5218 24.08 15.2335 24.08H15.2969L15.7492 24.0567L15.7311 24.5567C15.6889 25.61 16.5786 26.6167 17.5286 26.6167H17.592L18.0444 26.5933L18.0233 27.0933C17.9901 27.9067 18.5179 28.6933 19.1965 29.0067L35.6725 10.7967C36.3632 10.0333 36.3632 8.79333 35.6725 8.03L32.545 4.57333C32.2012 4.19 31.7458 4 31.2934 4Z",
    fill: "#424242"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_108",
    x1: 14.4765,
    y1: -1.22223,
    x2: 14.4765,
    y2: 39.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_108",
    x1: 15.2549,
    y1: 8.35592,
    x2: 15.2549,
    y2: 32.5733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006854,
    stopColor: "#FFECB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_108",
    x1: 12.055,
    y1: 22.6187,
    x2: 12.055,
    y2: 33.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_108",
    x1: 29.4175,
    y1: 6.01663,
    x2: 29.4175,
    y2: 16.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_108",
    x1: 31.8661,
    y1: 2.57402,
    x2: 31.8661,
    y2: 12.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26_108",
    x1: 22.6775,
    y1: 6.97396,
    x2: 22.6775,
    y2: 25.2653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26_108",
    x1: 32.1014,
    y1: 12.9003,
    x2: 19.8044,
    y2: 24.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26_108",
    x1: 28.1395,
    y1: 8.52146,
    x2: 15.8425,
    y2: 19.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoEmoji);
export default __webpack_public_path__ + "static/media/memo-emoji.076cfe86db5f47b5239721eace79dba0.svg";
export { ForwardRef as ReactComponent };